// Whether the trace canvas holds the reading panel. The canvas carries the
// trace's name, its facts and its controls itself, so the panel's own header
// line and the lanes view's control rows stand aside while it is up; this is
// how they hear about it without the canvas reaching into them.
import { useSyncExternalStore } from "react";

let on = false;
const subscribers = new Set();

export function setTraceCanvasMode(next) {
  const value = !!next;
  if (value === on) return;
  on = value;
  for (const fn of subscribers) fn();
}

function subscribe(fn) {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
}

export function useTraceCanvasMode() {
  return useSyncExternalStore(subscribe, () => on, () => false);
}
